export default "__VITE_ASSET__fzwhSdE3__"